































import Vue from 'vue'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { QcqOperations } from '@/types/enums'
import {
  GridOptions,
  QcqCommonGridItem,
  QcqDataDomain
} from '@/types'
import { hexToRgba } from '@/services/hex-to-rgba'

interface ComponentData {
  gridData: Array<QcqCommonGridItem>
  gridOptions: GridOptions
  operation: typeof QcqOperations
  currentSelectedRowId: number
  overlayNoRowsTemplate: string
  showSearchField: boolean
  search: string | null
}

export default Vue.extend({
  name: 'QcqCommonGrid',

  components: {
    AgGridVue
  },

  props: {
    isAddEnabled: Boolean,
    label: String,
    onRowClickedParent: Function,
    onRowDoubleClickedParent: Function,
    showDialogParent: Function,
    data: {
      type: Array as () => Array<QcqCommonGridItem>
    }
  },

  computed: {
    isActiveAddButton (): boolean {
      return !(this.gridData.length > 0)
    },

    isActiveRemoveButton (): boolean {
      return (this.currentSelectedRowId === -1)
    },

    isActiveEditButton (): boolean {
      return (this.currentSelectedRowId === -1)
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    isSearchEnabled (): boolean {
      return this.gridData.length > 0
    },

    filteredGridData (): any[] {
      if(this.search) {
        return this.gridData.filter((item: any) => {
          return item.description.toLowerCase().includes(this.search!.toLowerCase())
        })
      } else {
        return this.gridData
      }
    }
  },

  watch: {
    data (newVal: Array<QcqDataDomain>): void {
      if (newVal && newVal.length > 0) {
        const gridData = newVal.map((item: QcqDataDomain) => {
          return item.commonGridData
        })
        this.currentSelectedRowId = -1
        this.gridData = gridData
      } else if (newVal && newVal.length === 0) {
        this.gridData = []
        this.currentSelectedRowId = -1
      }
    }
  },

  data (): ComponentData {
    return {
      gridData: [],
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('qcqQualificationPage.code'), field: 'code', width: 100 },
          { headerName: this.$t('qcqQualificationPage.description'), field: 'description' }
        ]
      },
      operation: QcqOperations,
      currentSelectedRowId: -1,
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      showSearchField: false,
      search: null
    }
  },

  methods: {
    onRowDataChanged () {
      //@ts-ignore
      this.gridOptions.api.sizeColumnsToFit()
    },

    onRowClicked (params: any) {
      this.onRowClickedParent(params.node.data.id)
      this.currentSelectedRowId = params.node.data.id
    },

    onRowDoubleClicked (params: any) {
      this.onRowDoubleClickedParent(params.node.data.id)
      this.currentSelectedRowId = params.node.data.id
    },

    showDialog (operation: number) {
      this.$emit('action', operation)
      this.showDialogParent(operation, this.currentSelectedRowId)
    },

    onSearchButtonClick (): void {
      this.showSearchField = !this.showSearchField
      if(!this.showSearchField) {
        this.search = null
      }
    }
  }
})
